import Breakpoint from "../../../Utils/js/Breakpoint";

const PER_PAGE_OPTIONS = [8, 16, 32];
const MAX_ADJACENT_PAGE_LINKS_PER_SIDE_MOBILE = 2;
const MAX_ADJACENT_PAGE_LINKS_PER_SIDE_TABLET = 3;
const MAX_ADJACENT_PAGE_LINKS_PER_SIDE = 4;

class PaginationControls {
    constructor(options) {
        this._pageNumberLabel = options.pageNumberLabel;
        this.$paginationRoot = options.$paginationRoot;
        this.$ = options.$;
        
        this.$pageSelector = this.$paginationRoot.find(".pagination__page-selector");
        
        this.$firstPage = this.$pageSelector.find(".pagination__page-link--first.pagination__page-link");
        this.$previousPage = this.$pageSelector.find(".pagination__page-link--previous.pagination__page-link");
        this.$nextPage = this.$pageSelector.find(".pagination__page-link--next.pagination__page-link");
        this.$lastPage = this.$pageSelector.find(".pagination__page-link--last.pagination__page-link");
        
        this.$perPageSelector = this.$paginationRoot.find(".pagination__per-page-selector");
        this.$perPage = this.$perPageSelector.find(".pagination__per-page");
        
        this.$pageLinkLeftSpacer = this.buildPageLinkSpacer();
        this.$pageLinkRightSpacer = this.buildPageLinkSpacer();
        
        this.isPaginating = true;
        this.displayedNumberOfItemsPerPage = 8;
        this.currentPage = 0;
        this.totalNumberOfItems = 0;
        this.maxAdjacentPageLinksPerSide = MAX_ADJACENT_PAGE_LINKS_PER_SIDE_MOBILE;
        
        this.allowPerPageConfiguration = false;
        this.fixedPerPageCount = 8;
        this.previousPerPageConfiguration = null;
        
        this._onPageSelectedListeners = [];
        this._onPaginationEnabledListeners = [];
        
        this.populatePerPageSelectorOptions();
        
        this.$perPage.change((event) => {
            this.perPage = this.$(event.target).val();
        })
        
        this.$firstPage.click(() => {
            this.page = 0;
            return false;
        });
        
        this.$lastPage.click(() => {
            this.page = this.totalPages - 1;
            return false;
        })
        
        this.$previousPage.click(() => {
            this.page = this.page - 1;
            return false;
        })
        
        this.$nextPage.click(() => {
            this.page = this.page + 1;
            return false;
        })
        
        this.$pageSelector.on("click",
        ".pagination__page-link--specific",
        (event) => {
            this.page = this.$(event.currentTarget).data("page");
            return false;
        });
        
        Breakpoint.onChange.addListener((newBreakpoint, oldBreakpoint) => this.onBreakpointStateChange(newBreakpoint, oldBreakpoint));
        this.onBreakpointStateChange(Breakpoint.lastBreakpoint, null);
    }
    
    get showPerPageSelector() {
        return this.allowPerPageConfiguration;
    }
    
    set showPerPageSelector(willShowPerPage) {
        if (!willShowPerPage) {
            if (this.allowPerPageConfiguration) {
                // Save previous user-selected per page value
                this.previousPerPageConfiguration = this.perPage;
            }
            this.allowPerPageConfiguration = false;
            this.perPage = this.fixedPerPageCount;
        } else {
            if (!this.allowPerPageConfiguration && this.previousPerPageConfiguration) {
                // If the user saved a per page value previously, use it
                this.perPage = this.previousPerPageConfiguration;
                this.$perPage.val(this.perPage);
                this.previousPerPageConfiguration = null;
            }
            this.allowPerPageConfiguration = true;
        }
        
        this.$perPageSelector.toggleClass("display-none", !willShowPerPage);
    }
    
    onBreakpointStateChange(newBreakpoint, oldBreakpoint) {
        if (newBreakpoint === Breakpoint.mobile) {
            this.maxAdjacentPageLinksPerSide = MAX_ADJACENT_PAGE_LINKS_PER_SIDE_MOBILE;
        } else if (newBreakpoint === Breakpoint.tablet) {
            this.maxAdjacentPageLinksPerSide = MAX_ADJACENT_PAGE_LINKS_PER_SIDE_TABLET;
        } else {
            this.maxAdjacentPageLinksPerSide = MAX_ADJACENT_PAGE_LINKS_PER_SIDE;
        }
        
        this.showPerPageSelector = newBreakpoint === Breakpoint.desktop;
        
        this.updatePageLinkSpacers();
    }
    
    populatePageLinks() {
        this.$pageSelector.find(".pagination__page-link--specific").detach();
        
        let $lastPageLink = this.$previousPage;
        
        for (let i = 0; i < this.totalPages; i++) {
            let $pageLink = this.buildPageLink(i);
            $lastPageLink.after($pageLink);
            $lastPageLink = $pageLink;
        }
        
        this.updatePageLinks();
    }
    
    updatePageLinks() {
        let $pageLinks = this.$pageSelector.find(".pagination__page-link--specific");
        $pageLinks
        .toggleClass("pagination__page-link--active", false)
        .attr("aria-current", null);
        
        $pageLinks.filter("[data-page=" + this.page + "]")
        .toggleClass("pagination__page-link--active", true)
        .attr("aria-current", "page");
        
        this.updatePageLinkSpacers();
    }
    
    updatePageLinkSpacers() {
        let $pageLinks = this.$pageSelector.find(".pagination__page-link--specific");
        
        let $currentPageLink = $pageLinks.filter("[data-page=" + this.page + "]");
        let currentPageIndex = $currentPageLink.index(".pagination__page-link--specific");
        
        let newLeftSpacerIndex = currentPageIndex - this.maxAdjacentPageLinksPerSide;
        let newRightSpacerIndex = currentPageIndex + this.maxAdjacentPageLinksPerSide;
        let rightSpacerIndexOffset = 0;
        let leftSpacerIndexOffset = 0;
        
        if (newLeftSpacerIndex < 0) {
            rightSpacerIndexOffset = -newLeftSpacerIndex;
            newLeftSpacerIndex = 0;
        }
        
        if (newRightSpacerIndex > $pageLinks.length - 1) {
            leftSpacerIndexOffset = newRightSpacerIndex - $pageLinks.length + 1;
            newRightSpacerIndex = $pageLinks.length - 1;
        }
        
        newLeftSpacerIndex -= leftSpacerIndexOffset;
        newRightSpacerIndex += rightSpacerIndexOffset;
        
        if (newLeftSpacerIndex < 0) {
            newLeftSpacerIndex = 0;
        }
        
        if (newRightSpacerIndex > $pageLinks.length - 1) {
            newRightSpacerIndex = $pageLinks.length - 1;
        }
        
        this.$pageLinkLeftSpacer.detach();
        this.$pageLinkRightSpacer.detach();
        
        $pageLinks.eq(newLeftSpacerIndex).before(this.$pageLinkLeftSpacer);
        $pageLinks.eq(newRightSpacerIndex).after(this.$pageLinkRightSpacer);
    }
    
    updateFixedPageLinks() {
        let currentPage = this.page;
        let totalPages = this.totalPages;
        
        let canDoPrevious = currentPage > 0;
        let canDoNext = currentPage < totalPages - 1;
        let canDoFirst = currentPage > 0;
        let canDoLast = totalPages - 1 - this.currentPage > 0;
        
        this.$firstPage
        .toggleClass("pagination__page-link--disabled", !canDoFirst)
        .attr("aria-disabled", !canDoFirst);
        this.$previousPage
        .toggleClass("pagination__page-link--disabled", !canDoPrevious)
        .attr("aria-disabled", !canDoPrevious);
        this.$nextPage
        .toggleClass("pagination__page-link--disabled", !canDoNext)
        .attr("aria-disabled", !canDoNext);
        this.$lastPage
        .toggleClass("pagination__page-link--disabled", !canDoLast)
        .attr("aria-disabled", !canDoLast);
    }
    
    populatePerPageSelectorOptions() {
        this.$perPage.append(PER_PAGE_OPTIONS.map(v => {
            return this.$("<option />").val(v).text(v);
        }));
    }
    
    buildPageLink(pageNumber) {
        let $text = this.$("<span class=\"pagination__page-number\"></span>").text(pageNumber + 1);
        return this.$("<a class=\"pagination__page-link pagination__page-link--specific\" role=\"link\" tabindex=\"0\" clickable></a>")
        .html($text)
        .attr("data-page", pageNumber)
        .attr("aria-label", this._pageNumberLabel.replace("{0}", pageNumber + 1));
    }
    
    buildPageLinkSpacer() {
        return this.$("<span class=\"pagination__page-link pagination__page-link--spacer\" aria-hidden=\"true\">...</span>");
    }
    
    get range() {
        return [
            this.firstElementIndex,
            this.lastElementIndex
        ];
    }
    
    get enabled() {
        return this.isPaginating;
    }
    
    set enabled(value) {
        let willPaginate = !!value;
        
        if (willPaginate === this.isPaginating) {
            return;
        }
        
        this.isPaginating = willPaginate;
        
        this.$paginationRoot.toggleClass("pagination--disabled", !willPaginate);
        
        this.invokePaginationEnabledListeners(willPaginate);
        
        if (this.enabled) {
            this.populatePageLinks();
            this.updateFixedPageLinks();
            this.invokePageSelectedListenersWithCurrentState();
        }
    }
    
    get totalItems() {
        return this.totalNumberOfItems;
    }
    
    set totalItems(value) {
        let totalItems = value;
        
        if (this.totalItems === totalItems) {
            return;
        }
        
        let newPage = this.currentPage;
        
        if (totalItems < this.totalItems) {
            // Reducing number of pages = must change page if current page is too large
            newPage = Math.min(newPage, Math.floor(totalItems / this.perPage));
        }
        
        this.totalNumberOfItems = totalItems;
        
        if (this.enabled) {
            this.populatePageLinks();
        }
        
        const samePage = this.page === newPage;
        this.page = newPage;
        
        if (this.enabled && samePage) {
            this.updateFixedPageLinks();
            this.invokePageSelectedListenersWithCurrentState();
        }
        
    }
    
    get perPage() {
        return this.displayedNumberOfItemsPerPage;
    }
    
    set perPage(value) {
        let perPage = value;
        
        if (this.displayedNumberOfItemsPerPage === perPage) {
            return;
        }
        
        // work out offset to first displayed element for current page
        let newPage = Math.floor(this.firstElementIndex / perPage);
        
        this.displayedNumberOfItemsPerPage = perPage;
        
        const samePage = this.page === newPage;
        
        if (this.enabled) {
            this.populatePageLinks();
        }
        
        this.page = newPage;
        
        if (this.enabled && samePage) {
            this.updateFixedPageLinks();
            this.invokePageSelectedListenersWithCurrentState();
        }
    }
    
    get page() {
        return this.currentPage;
    }
    
    set page(value) {
        let newPage = value;
        
        if (newPage < 0) {
            newPage = 0;
        }
        
        if (newPage > this.totalPages - 1) {
            newPage = this.totalPages - 1;
        }
        
        if (this.currentPage === newPage) {
            return;
        }
        
        let oldPage = this.currentPage;
        this.currentPage = newPage;
        
        if (this.enabled) {
            this.updatePageLinks();
            this.updateFixedPageLinks();
            this.invokePageSelectedListenersWithCurrentState(oldPage);
        }
    }
    
    get firstElementIndex() {
        return this.firstElementIndexForPage(this.page, this.perPage);
    }
    
    get lastElementIndex() {
        return this.lastPossibleElementIndexForPage(this.page, this.perPage, this.totalItems);
    }
    
    get totalPages() {
        return this.totalPagesForPerPage(this.perPage, this.totalItems);
    }
    
    firstElementIndexForPage(page, perPage) {
        return page * perPage;
    }
    
    lastElementIndexForPage(page, perPage) {
        return this.firstElementIndexForPage(page + 1, perPage) - 1;
    }
    
    lastPossibleElementIndexForPage(page, perPage, totalNumberOfItems) {
        let firstElementIndex = this.firstElementIndexForPage(page, perPage);
        let itemsOnPage = totalNumberOfItems - 1 - (page * perPage);
        
        return firstElementIndex + Math.min(perPage - 1, Math.max(0, itemsOnPage));
    }
    
    totalPagesForPerPage(perPage, totalNumberOfItems) {
        return Math.ceil(totalNumberOfItems / perPage);
    }
    
    addPageSelectedListener(callback) {
        if (this._onPageSelectedListeners.indexOf(callback) === -1) {
            this._onPageSelectedListeners.push(callback);
        }
    }
    
    invokePageSelectedListeners(event) {
        for (let i = 0, x = this._onPageSelectedListeners.length; i < x; i++) {
            this._onPageSelectedListeners[i].bind(this)(event);
        }
    }
    
    invokePageSelectedListenersWithCurrentState(oldPage) {
        let event = {
            newPage: this.currentPage,
            range: this.range
        };
        
        if (typeof oldPage !== typeof undefined) {
            event.oldPage = oldPage
        }
        
        this.invokePageSelectedListeners(event);
    }
    
    addPaginationEnabledListener(callback) {
        if (this._onPaginationEnabledListeners.indexOf(callback) === -1) {
            this._onPaginationEnabledListeners.push(callback);
        }
    }
    
    invokePaginationEnabledListeners(event) {
        for (let i = 0, x = this._onPaginationEnabledListeners.length; i < x; i++) {
            this._onPaginationEnabledListeners[i].bind(this)(event);
        }
    }
}
export default PaginationControls;